import startCase from 'lodash/startCase'
import unique from 'lodash/uniq'
export const formatString = (str = '') => {
  return startCase(str.toLowerCase())
}

export const formatEditorValues = (content = '') => {
  return content.replace(new RegExp('\r?<p></p>', 'g'), '<p class="nl">&nbsp;</p>')
}

export const formatSerialNumber = (value = '') => {
  const pattern = /-+/g
  const str = value.replace(pattern, '')

  return [str, str.match(/.{1,4}/g).join('-')]
}

export const formatNumber = (num, decimal = 0) => groupNumber(parseFloat(num).toFixed(decimal))

export const groupNumber = num => {
  const tokens = num.toString().split('.')
  return `${tokens[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}${tokens[1] ? `.${tokens[1]}` : ''}`
}

export const filterErrors = object =>
  Object.keys(object)
    .map(i => object[i])
    .filter(i => i != null)

export const sort = (items = [], key) => {
  if (key) {
    return items.slice().sort((item1, item2) => (item1[key] ? item1[key].localeCompare(item2[key]) : 0))
  } else {
    return items.slice().sort((item1, item2) => (item1 ? item1.localeCompare(item2) : 0))
  }
}

export const sortByNumber = (items = [], key) => {
  if (key) {
    return items.slice().sort((item1, item2) => (item1.hasOwnProperty(key) ? item1[key] - item2[key] : 0))
  } else {
    return items.slice().sort((item1, item2) => item1 - item2)
  }
}

export const prettyPrintJson = (value, space = 2) => {
  return value && JSON.stringify(JSON.parse(JSON.stringify(value)), null, space)
}

export const kbToSizes = (kb, defaultUnit = 'GB') => {
  const localDefaultUnit = defaultUnit || defaultUnit.toUpperCase()

  if (!kb) {
    return `0 ${localDefaultUnit}`
  }

  const units = ['KB', 'MB', 'GB', 'TB']
  let index = parseInt(Math.floor(Math.log(kb) / Math.log(1024)), 10)

  if (index == 0) {
    const defaultUnitIndex = units.findIndex(item => item === localDefaultUnit)
    if (defaultUnitIndex !== index) {
      index = defaultUnitIndex
    } else {
      return `${kb} ${units[index]}`
    }
  }
  const converted = kb / Math.pow(1024, index)
  let value

  if (converted > 99) {
    value = converted.toFixed()
  } else {
    value = converted.toFixed(1)
  }

  const decimals = value.toString().split('.')
  if (decimals.length > 1) {
    if (parseInt(decimals[1], 10) <= 0) {
      value = decimals[0]
    }
  }

  return `${value} ${units[index]}`
}

export const convertToInt = value =>
  value && typeof value === 'string' ? parseInt(value.replace(/,/g, ''), 10) : value

export const toOrdinalNumber = value => {
  let tenths = value % 10
  let hundreds = value % 100
  if (tenths === 1 && hundreds !== 11) {
    return value + 'st'
  }
  if (tenths === 2 && hundreds !== 12) {
    return value + 'nd'
  }
  if (tenths === 3 && hundreds !== 13) {
    return value + 'rd'
  }
  return value + 'th'
}

export const getValueByPath = (form, path, defaultValue) =>
  form &&
  String(path)
    .split('.')
    .reduce((item, key) => {
      try {
        item = item[key] || defaultValue
      } catch (ex) {
        return defaultValue
      }
      return item
    }, form)

export const setValueByPath = (form, path, value) => {
  let field = form
  return (
    field &&
    String(path)
      .split('.')
      .forEach((key, index, tokens) => {
        if (index === tokens.length - 1) {
          field[key] = value
        } else {
          if (!field[key]) {
            field[key] = {}
          }
          field = field[key]
        }
      })
  )
}

export const selectMany = (items, selector) => items.map(selector).flat()

export const formatSerialNo = value => {
  return (
    value &&
    value
      .replace(/\s\s+/g, ' ') // replace all known space types with just a single space
      .replace(/[-]/g, '')
      .replace(/([0-9a-zA-Z]{4})(?!$|\s)/g, '$1-') // grouping should end with either end of string or a space
      .trim()
      .toUpperCase()
  )
}

export const getDuplicates = (items, key) => {
  if (items.length) {
    const duplicates = items.reduce((list, item) => {
      if (items.indexOf(item) !== items.lastIndexOf(item)) {
        list.push(item)
      }
      return list
    }, [])
    return unique(duplicates, key)
  }
  return []
}

export const isObject = value => {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

const LEGACY_DRAFT_ATTACHMENTS_KEY = 'draft-attachments'
const LEGACY_DRAFT_ATTACHMENT_UNIQUE_ID_KEY = 'draft-attachmentUniqueId'

export const ATTACHMENT_DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000

export const initTabId = () => {
  if (!sessionStorage.getItem('pts-tab-id')) {
    sessionStorage.setItem('pts-tab-id', String(Date.now()))
  }
}

export const getTabId = () => sessionStorage.getItem('pts-tab-id') || ''

const getDraftKey = (name, draftScope) => {
  if (draftScope === undefined || draftScope === null || draftScope === '') {
    throw new Error(`Draft key "${name}" requires an explicit draft scope`)
  }
  return `draft-${name}-${draftScope}-${getTabId()}`
}

export const getDraftAttachmentsKey = draftScope => getDraftKey('attachments', draftScope)

export const getDraftAttachmentUniqueIdKey = draftScope => getDraftKey('attachmentUniqueId', draftScope)

export const clearDraftAttachmentKeys = draftScope => {
  localStorage.removeItem(getDraftAttachmentsKey(draftScope))
  localStorage.removeItem(getDraftAttachmentUniqueIdKey(draftScope))
}

export const clearLegacyDraftAttachmentKeys = () => {
  localStorage.removeItem(LEGACY_DRAFT_ATTACHMENTS_KEY)
  localStorage.removeItem(LEGACY_DRAFT_ATTACHMENT_UNIQUE_ID_KEY)
}

export const clearAllDraftAttachmentKeys = () => {
  Object.keys(localStorage)
    .filter(key => key.startsWith('draft-'))
    .forEach(key => localStorage.removeItem(key))
}



// WEBPACK FOOTER //
// ./src/Helpers/Utils.js